import { Layers, TrendingUp, Users } from "lucide-react";

const PERSONAS = [
  {
    icon: Layers,
    title: "Platform & infra teams",
    description:
      "You run shared AWS infrastructure and internal platforms for the rest of the company. Infralyst watches for cost savings and turns them into Terraform PRs your team can review on your own cadence.",
  },
  {
    icon: TrendingUp,
    title: "Fast-growing product teams",
    description:
      "Your usage (and bill) are growing faster than your headcount. Infralyst gives you conservative, code-level savings without a full FinOps program or weeks spent digging through CloudWatch and spreadsheets.",
  },
  {
    icon: Users,
    title: "Ops agencies & consultancies",
    description:
      "You manage AWS for multiple clients and need a repeatable way to find savings. Infralyst gives you one workflow across every account, with PRs your clients can review themselves.",
  },
] as const;

export function BuiltFor(): React.ReactElement {
  return (
    <section className="py-16 px-4">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-4xl font-bold text-center mb-4">
          Built for teams who own the{" "}
          <span className="text-primary">AWS bill</span>
        </h2>
        <p className="text-center text-surface-foreground/80 mb-16 max-w-2xl mx-auto">
          Infralyst is for teams who care about costs but don't want another
          dashboard to babysit.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {PERSONAS.map(({ icon: Icon, title, description }) => (
            <div
              key={title}
              className="group p-6 rounded-3xl border bg-background/50 hover:border-primary/20 hover:bg-primary/5 transition-colors"
            >
              <div className="size-12 rounded-full bg-primary/10 text-primary flex items-center justify-center mb-4">
                <Icon className="size-6" />
              </div>
              <h3 className="text-xl font-bold mb-3">{title}</h3>
              <p className="text-surface-foreground/80 text-sm leading-relaxed">
                {description}
              </p>
            </div>
          ))}
        </div>
        <p className="text-center text-surface-foreground/60 text-sm mt-12">
          Not sure if it's a fit?{" "}
          <a href="/signup" className="text-primary hover:underline">
            Start on Free
          </a>{" "}
          and see what Infralyst finds for your AWS accounts.
        </p>
      </div>
    </section>
  );
}
